<template lang="html">
  <div>
    <v-menu
    v-model="menuData"
    transition="scroll-y-transition"
    max-width="290px"
    offset-y
    :close-on-content-click="false"
    :nudge-left="-40"
    :nudge-top="25"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
        :label="label"
        v-model="dataFormatada"
        :rules="rules"
        :clearable="clearable"
        :required="required"
        readonly
        v-on="on"
        prepend-icon="event"
        :disabled="disabled"
        >
        </v-text-field>
      </template>
      <v-date-picker
      v-model="data"
      type="month"
      locale="pt-br"
      scrollable
      autosave
      @input="setData()"
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
  import dates from '@/utils/dates'

  export default {
    props: ['label', 'value', 'rules', 'clearable', 'required', 'disabled'],
    data: () => ({
      dates: dates,
      data: '',
      dataFormatada: '',
      menuData: false
    }),
    watch: {
      value: function (val) {
        if (!val) {
          this.data = ''
          this.dataFormatada = ''
        } else {
          this.data = val
          this.dataFormatada = this.dates.formatMonthYear(val) // MM/AAAA
        }
      },
      dataFormatada: function (val) {
        if (val === null) {
          this.data = ''
          this.$emit('input', undefined)
        }
      }
    },
    methods: {
      setData () {
        this.$emit('input', this.data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// c-date-month-menu.vue?0742323c